import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  width: 100vw;

  position: fixed;
  top: 0;
  z-index: 100;

  background: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
`

export const Wrapper = styled.div`
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  width: 90%;
  max-width: 500px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border-radius: 1rem;
  padding: 2rem;

  h2 {
    font-size: 1.125rem;
    line-height: 1.625rem;
    font-weight: 400;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    max-width: 147px;
    text-align: center;
  }
`

export const Loader = styled.img`
  animation: spin 1s linear infinite;
  -webkit-animation: spin 1s linear infinite;

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const ImageModeWrapper = styled.div`
  padding: 2rem 0;

  @media only screen and (max-width: 900px) {
    display: none;
  }
`
